import { Button } from "antd";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Ong } from "../../../utils/entities/Ong";

const Title = (props: any) => {
  const ong: Ong = props.ong;
  const navigate_to_map = props.navigate_to_map;

  console.log();

  return (
    <div className="titulo-container">
      <Button
        className="ant-btn ant-btn-primary regresar-mapa"
        onClick={navigate_to_map}
      >
        <FontAwesomeIcon icon={faArrowLeft} />
      </Button>
      <div className="titulo">{ong.name}</div>
    </div>
  );
};

export default Title;
